import * as defaultImport from "@splunk/visualizations/Bar";
export * from "@splunk/visualizations/Bar";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
